import { Announcement, AnnouncementType, AnnouncementPriority } from '../models/announcement.model';

export const MOCK_ANNOUNCEMENTS: Announcement[] = [
  {
    id: 1,
    titleKey: 'announcements.scheduled-water-maintenance',
    title: 'announcements.scheduled-water-maintenance',
    contentKey: 'announcements.scheduled-water-maintenance-content',
    content: 'announcements.scheduled-water-maintenance-content',
    type: AnnouncementType.MAINTENANCE,
    createdDate: new Date('2024-01-20T10:00:00Z'),
    updatedDate: new Date('2024-01-20T10:00:00Z'),
    authorKey: 'announcements.property-management',
    author: 'announcements.property-management',
    priority: AnnouncementPriority.MEDIUM,
    isActive: true,
    tags: ['maintenance', 'water', 'scheduled'],
  },
  {
    id: 2,
    titleKey: 'announcements.community-bbq-event',
    title: 'announcements.community-bbq-event',
    contentKey: 'announcements.community-bbq-event-content',
    content: 'announcements.community-bbq-event-content',
    type: AnnouncementType.EVENT,
    createdDate: new Date('2024-01-15T14:30:00Z'),
    updatedDate: new Date('2024-01-15T14:30:00Z'),
    authorKey: 'announcements.community-events-team',
    author: 'announcements.community-events-team',
    priority: AnnouncementPriority.LOW,
    isActive: true,
    tags: ['event', 'community', 'bbq', 'social'],
  },
  {
    id: 3,
    titleKey: 'announcements.emergency-power-outage',
    title: 'announcements.emergency-power-outage',
    contentKey: 'announcements.emergency-power-outage-content',
    content: 'announcements.emergency-power-outage-content',
    type: AnnouncementType.EMERGENCY,
    createdDate: new Date('2024-01-18T19:45:00Z'),
    updatedDate: new Date('2024-01-18T19:45:00Z'),
    authorKey: 'announcements.emergency-response-team',
    author: 'announcements.emergency-response-team',
    priority: AnnouncementPriority.CRITICAL,
    isActive: true,
    tags: ['emergency', 'power', 'outage', 'safety'],
  },
  {
    id: 4,
    titleKey: 'announcements.new-parking-policy',
    title: 'announcements.new-parking-policy',
    contentKey: 'announcements.new-parking-policy-content',
    content: 'announcements.new-parking-policy-content',
    type: AnnouncementType.GENERAL,
    createdDate: new Date('2024-01-12T09:15:00Z'),
    updatedDate: new Date('2024-01-12T09:15:00Z'),
    authorKey: 'announcements.property-management',
    author: 'announcements.property-management',
    priority: AnnouncementPriority.MEDIUM,
    isActive: true,
    tags: ['parking', 'policy', 'guest', 'towing'],
  },
  {
    id: 5,
    titleKey: 'announcements.pool-maintenance-complete',
    title: 'announcements.pool-maintenance-complete',
    contentKey: 'announcements.pool-maintenance-complete-content',
    content: 'announcements.pool-maintenance-complete-content',
    type: AnnouncementType.GENERAL,
    createdDate: new Date('2024-01-08T16:20:00Z'),
    updatedDate: new Date('2024-01-08T16:20:00Z'),
    authorKey: 'announcements.maintenance-team',
    author: 'announcements.maintenance-team',
    priority: AnnouncementPriority.LOW,
    isActive: true,
    tags: ['pool', 'maintenance', 'open', 'safety'],
  },
];
